import { FullScreenLoader } from '@/components/molecules/FullScreenLoader';
import React from 'react';

/**
 * While auth is loading or the user is already authenticated, do not render Welcome.
 * Logged-in users must never flash the marketing page before redirect to home.
 */
export function renderWelcomeWebAuthGate(
  authLoading: boolean,
  isAuthenticated: boolean,
): React.ReactElement | undefined {
  if (!authLoading && !isAuthenticated) {
    return undefined;
  }

  return <FullScreenLoader visible />;
}
